
import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { ObtenerTipoIrregular } from '../connections/catalogos/TipoIrregularConnection';
import { ObtenerEtapa } from '../connections/catalogos/EtapaConnection';
import { ObtenerSubEtapa } from '../connections/catalogos/SubEtapaConnection';
import { BuscarSecretariosIrregular, ObtenerUsuarioJuez } from '../connections/admin/UsuarioConnection';
import { EditarIrregular } from '../connections/tribunal/ExpedienteVirtualConnection';

import { IrregularProps } from '../interfaces/tribunal/ExpedienteVirtualInterface';
import { TipoIrregularProps } from '../interfaces/catalogos/TipoIrregularInterface';
import { EtapaProps } from '../interfaces/catalogos/EtapaInterface';
import { SubEtapaProps } from '../interfaces/catalogos/SubEtapaInterface';
import { UsuarioJuezProps, UsuarioSecretarioProps } from '../interfaces/admin/UsuarioInterface';

interface Props {
    openDialog:         boolean;
    handleCloseDialog:  () => void;
    irregular:          IrregularProps;
    onGuardar:          ( irregular: IrregularProps ) => void;
}

export const DialogEditarIrregular = ( { openDialog, handleCloseDialog, irregular, onGuardar }: Props ) => {

    const dispatch = useDispatch();

    const [guardando, setGuardando] = useState( false );

    const [tipoIrregularArray, setTipoIrregularArray] = useState<TipoIrregularProps[]>( [] );
    const [etapaArray, setEtapaArray] = useState<EtapaProps[]>( [] );
    const [subEtapaArray, setSubEtapaArray] = useState<SubEtapaProps[]>( [] );
    const [juezArray, setJuezArray] = useState<UsuarioJuezProps[]>( [] );
    const [secretariosArray, setSecretariosArray] = useState<UsuarioSecretarioProps[]>( [] );

    const [tipoIrregularEditado, setTipoIrregularEditado] = useState( 0 );
    const [etapaEditada, setEtapaEditada] = useState( 0 );
    const [subEtapaEditada, setSubEtapaEditada] = useState( 0 );
    const [subEtapaEditadaTemp, setSubEtapaEditadaTemp] = useState( 0 );
    const [juezEditado, setJuezEditado] = useState( 0 );
    const [secretarioEditado, setSecretarioEditado] = useState( 0 );

    const handleGuardar = async () => {

        setGuardando( true );

        const tipoIrregularDescripcion = tipoIrregularArray.find( ({ idTipoIrregular }) => idTipoIrregular === tipoIrregularEditado )?.descripcion ?? '';
        const etapaDescripcion = etapaArray.find( ({ idEtapa }) => idEtapa === etapaEditada )?.descripcion ?? '';
        const subEtapaDescripcion = subEtapaArray.find( ({ idSubEtapa }) => idSubEtapa === subEtapaEditada )?.descripcion ?? '';
        const juezDescripcion = juezArray.find( ({ idUsuario }) => idUsuario === juezEditado )?.nombreCompleto ?? '';
        const secretarioDescripcion = secretariosArray.find( ({ id }) => id === secretarioEditado )?.nombreCompleto ?? '';

        await EditarIrregular({
            idIrregular:        irregular.idIrregular,
            idTipoIrregular:    tipoIrregularEditado,
            idJuez:             juezEditado,
            idSecretario:       secretarioEditado,
            idEtapa:            etapaEditada,
            idSubEtapa:         subEtapaEditada,
        }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if( success ){

                    onGuardar({
                        ...irregular,
                        idTipoIrregular:    tipoIrregularEditado,
                        tipoIrregular:      tipoIrregularDescripcion,
                        idEtapa:            etapaEditada,
                        etapa:              etapaDescripcion,
                        idSubEtapa:         subEtapaEditada,
                        subEtapa:           subEtapaDescripcion,
                        idJuez:             juezEditado,
                        juez:               juezDescripcion,
                        idSecretario:       secretarioEditado,
                        secretario:         secretarioDescripcion,
                    });

                    dispatch( openSnackbar({ message, variant: 'success' }) );
                    handleCloseDialog();

                }
                else {

                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }

                setGuardando( false );

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener(){
            await ObtenerTipoIrregular().then( resp => {
                setTipoIrregularArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerEtapa().then( resp => {
                setEtapaArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerUsuarioJuez().then( resp => {
                setJuezArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await BuscarSecretariosIrregular().then( resp => {
                setSecretariosArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){

            setSubEtapaEditada( 0 );
            setSubEtapaArray( [] );

            await ObtenerSubEtapa( etapaEditada ).then( resp => {
                setSubEtapaArray( resp );
            });

        }

        if( etapaEditada !== 0 ){
            Obtener();
        }

    }, [ etapaEditada ]);

    useEffect(() => {

        if( openDialog ){

            setTipoIrregularEditado( irregular.idTipoIrregular );
            setEtapaEditada( irregular.idEtapa );
            setSubEtapaEditadaTemp( irregular.idSubEtapa );
            setJuezEditado( irregular.idJuez );
            setSecretarioEditado( irregular.idSecretario );

        }

    }, [ openDialog, irregular ]);

    useEffect(() => {

        if( subEtapaEditadaTemp !== 0 && subEtapaArray.length !== 0 ){
            setSubEtapaEditada( subEtapaEditadaTemp );
        }

    }, [ subEtapaEditadaTemp, subEtapaArray.length ]);

    return (

        <Dialog
            fullWidth
            maxWidth='md'
            open={ openDialog }
            onClose={ () => {} }
        >

            <DialogTitle>Editar irregular</DialogTitle>

            <DialogContent>

                <Grid container spacing={3} sx={{ mt: 1 }}>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Tipo de irregular</InputLabel>

                            <Select
                                notched
                                label='Tipo de irregular'
                                value={ tipoIrregularEditado }
                                onChange={ (e) => setTipoIrregularEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    tipoIrregularArray.map( ({ idTipoIrregular, descripcion }) => (
                                        <MenuItem key={ idTipoIrregular } value={ idTipoIrregular }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Etapa</InputLabel>

                            <Select
                                notched
                                label='Etapa'
                                value={ etapaEditada }
                                onChange={ (e) => { setSubEtapaEditada( 0 ); setEtapaEditada( e.target.value as number ); } }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    etapaArray
                                    .filter( ({ idEtapa }) => idEtapa === 17 )
                                    .map( ({ idEtapa, descripcion }) => (
                                        <MenuItem key={ idEtapa } value={ idEtapa }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Subetapa</InputLabel>

                            <Select
                                notched
                                label='Subetapa'
                                value={ subEtapaEditada }
                                onChange={ (e) => setSubEtapaEditada( e.target.value as number ) }
                                disabled={ etapaEditada === 0 || subEtapaArray.length === 0 }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    subEtapaArray.map( ({ idSubEtapa, descripcion }) => (
                                        <MenuItem key={ idSubEtapa } value={ idSubEtapa }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>                
                    
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Juez</InputLabel>

                            <Select
                                notched
                                label='Juez'
                                value={ juezEditado }
                                onChange={ (e) => setJuezEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    juezArray.map( ({ idUsuario, nombreCompleto }) => (
                                        <MenuItem key={ idUsuario } value={ idUsuario }>{ nombreCompleto }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>
            
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Secretario(a) de trámite</InputLabel>

                            <Select
                                notched
                                label='Secretario(a) de trámite'
                                value={ secretarioEditado }
                                onChange={ (e) => setSecretarioEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    secretariosArray.map( ({ id, nombreCompleto }) => (
                                        <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>              

                </Grid>

            </DialogContent>

            <DialogActions>
                <Button color='secondary' onClick={ handleCloseDialog } disabled={ guardando }>Cancelar</Button>
                <Button variant='contained' loading={ guardando } onClick={ handleGuardar }>Guardar</Button>
            </DialogActions>

        </Dialog>

    );

}
